export default {"src":"https://assets-v2.i-scmp.com/production/_next/static/media/loading.e2722467.gif","height":48,"width":48,"blurWidth":0,"blurHeight":0};